const ENV = {
  BASE_API_URL: process.env.REACT_APP_BASE_API_URL,
  GOOGLE_OAUTH2_CLIENT_ID: process.env.REACT_APP_GOOGLE_OAUTH2_CLIENT_ID
};

export default ENV;